import {
    CREATE_ASSET_LINK_SUCCESS,
    FETCH_ASSET_LINK_SUCCESS,
    GET_ASSET_LINK_SEARCH_SUCCESS,
    GET_ASSET_LINK_SUCCESS, RESET_ASSET_LINK_SUCCESS,
    SAVE_ASSET_LINK_QUERY,
    FETCH_ASSET_LINK_BY_CODE_SUCCESS
} from "../../constants/ActionTypes";

const INIT_STATE = {
    total: 0,
    resources: [],
    searchResources: [],
    resource: {},
    edit: {},
    byCode: {},
    query: {},
    linkStatus: '',
};

export default (state = INIT_STATE, action) => {
    switch (action.type) {
        case SAVE_ASSET_LINK_QUERY: {
            return {
                ...state,
                query: action.query
            }
        }

        case GET_ASSET_LINK_SUCCESS: {
            const query = { ...state.query };
            // query['pagination'].total = action.count;

            return {
                ...state,
                query: query,
                resources: action.data,
                total: action.total,
            }
        }

        case GET_ASSET_LINK_SEARCH_SUCCESS: {
            return {
                ...state,
                searchResources: action.data,
            }
        }

        case CREATE_ASSET_LINK_SUCCESS: {
            return {
                ...state,
                resource: action.data,
                linkStatus: action.linkStatus,
            }
        }

        case RESET_ASSET_LINK_SUCCESS: {
            return {
                ...state,
                resource: {},
                linkStatus: '',
            }
        }

        case FETCH_ASSET_LINK_SUCCESS: {
            return {
                ...state,
                edit: action.data,
            }
        }

        case FETCH_ASSET_LINK_BY_CODE_SUCCESS: {
            return {
                ...state,
                byCode: action.data,
            }
        }
        default:
            return state;
    }
}
